module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgB7dbRDYJADAbg4gS6AYzARmyiGziCcQJ1AtwAR3AD3KCW5B6UIC1crxeTfknjg9C7X8wVAOccCxFLqpaqxzgdVQOWwuZjNz62Byu02AXTsAmBeg5ZQqCS0Ms+BCr56GcbApWMetqFQCUTfW1CoJIfvdOHQCUz/dOGQCXMGulCoBLBOlMhGoiFeraCtcYhWoiFek5UpWC9rxDc9YWgIdskpYLMfb+BP+cBcvMAuWkEOFPtioXonircG0XjGK1oP09YIQy3fu4ai2P0Beux05mjEeAombBj4dePfmHzSZybB8jN5wD4HIjjcyA1i79QVh4gN0mAmFMmOUmAB+Rz4y6QnEIlfXSgcGYvNDz5mhuS7BMIDWqqK9gYNn4HweadcwBvyD1NSARFjtkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu4.png
// module id = 8sFy
// module chunks = 1